import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d6b70fd8")

_pushScopeId("data-v-d6b70fd8")
const _hoisted_1 = { class: "p-d-inline-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.targetDefinition.applyTargetonKPI')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addKpiDialog()))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('kpi.targetDefinition.addKpiBtn')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    content: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.selectedKpi,
        loading: _ctx.loadingKpi,
        class: "editable-cells-table",
        dataKey: "id",
        responsiveLayout: "stack",
        breakpoint: "960px",
        "data-test": "selected-kpi-table"
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noElementSelected')), 1)
        ]),
        loading: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "kpiName",
            header: _ctx.$t('kpi.targetDefinition.kpiName'),
            key: "kpiName",
            sortable: true,
            class: "kn-truncated",
            headerStyle: _ctx.targetDefinitionDetailDecriptor.table.column.style
          }, null, 8, ["header", "headerStyle"]),
          _createVNode(_component_Column, {
            field: "value",
            header: _ctx.$t('kpi.targetDefinition.kpiValue'),
            key: "value",
            sortable: true,
            class: "kn-truncated",
            headerStyle: _ctx.targetDefinitionDetailDecriptor.table.column.style
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_InputNumber, {
                modelValue: slotProps.data[slotProps.column.props.field],
                "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                showButtons: "",
                mode: "decimal",
                minFractionDigits: 2
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header", "headerStyle"]),
          _createVNode(_component_Column, {
            headerStyle: "targetDefinitionDetailDecriptor.table.iconColumn.style",
            style: _ctx.targetDefinitionDetailDecriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.deleteKpi(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
})